<template>
    <div v-if="offer != undefined" class="w-full h-full">
        <FormModal v-if="showFormModal" @cancel="showFormModal = false"
            @confirm="showFormModal = false; requestApproval()"
            :valid="!(activateOfferRequest.splitOfCashbackPercentage.client > 100 || activateOfferRequest.splitOfCashbackPercentage.client < 0)"
            title="Request approval" submitButtonText="Request approval">
            <div v-if="!offer.cashbackRules[0].conditions[0].fixedDistributorCommission">
                <p>Set cashback split</p>
                <CustomInput :error="pecentageNotRight" v-model="activateOfferRequest.splitOfCashbackPercentage.endUser"
                    :min="0" :max="100" type="number" label="Your users cashback split percentage" />
                <CustomInput v-model="activateOfferRequest.splitOfCashbackPercentage.client" type="number" :min="0"
                    :max="100" :disabled="true" label="Your commission split percentage" />

                <CustomSelect v-model="activateOfferRequest.customerTierType"
                    :pre-select="activateOfferRequest.customerTierType" :options="trueOrFalse"
                    label="Offer avaliable to:" />

                <CustomCheckbox class="mt-2" v-if="activateOfferRequest.customerTierType == 'TIERED'"
                    v-model="selectedCustomerTiers" :options="customerSegments" label="Select customer Tiers" />


            </div>
            <div v-else>
                <CustomSelect v-model="activateOfferRequest.customerTierType"
                    :pre-select="activateOfferRequest.customerTierType" :options="trueOrFalse"
                    label="Make this offer avaliable to" />

                <CustomCheckbox class="mt-2" v-if="activateOfferRequest.customerTierType == 'TIERED'"
                    v-model="selectedCustomerTiers" :options="customerSegments" label="Select customer Tiers" />

            </div>
        </FormModal>

        <FormModal v-if="showEditFormModal" @cancel="showEditFormModal = false"
            @confirm="showEditFormModal = false; requestApproval()"
            :valid="!(activateOfferRequest.splitOfCashbackPercentage.client > 100 || activateOfferRequest.splitOfCashbackPercentage.client < 0)"
            title="Edit program offer" submitButtonText="Edit approval">
            <p>Offer may require re-approval if changed</p>
            <div v-if="!offer.cashbackRules[0].conditions[0].fixedDistributorCommission">
                <p>Set cashback split</p>
                <CustomInput :error="pecentageNotRight" v-model="activateOfferRequest.splitOfCashbackPercentage.endUser"
                    :min="0" :max="100" type="number" label="Your users cashback split percentage" />
                <CustomInput v-model="activateOfferRequest.splitOfCashbackPercentage.client" type="number" :min="0"
                    :max="100" :disabled="true" label="Your commission split percentage" />

                <CustomSelect v-model="activateOfferRequest.customerTierType"
                    :pre-select="activateOfferRequest.customerTierType" :options="trueOrFalse"
                    label="Offer avaliable to:" />

                <CustomCheckbox class="mt-2" v-if="activateOfferRequest.customerTierType == 'TIERED'"
                    v-model="selectedCustomerTiers" :options="customerSegments" label="Select customer Tiers" />


            </div>
            <div v-else>
                <CustomSelect v-model="activateOfferRequest.customerTierType"
                    :pre-select="activateOfferRequest.customerTierType" :options="trueOrFalse"
                    label="Make this offer avaliable to" />

                <CustomCheckbox class="mt-2" v-if="activateOfferRequest.customerTierType == 'TIERED'"
                    v-model="selectedCustomerTiers" :options="customerSegments" label="Select customer Tiers" />

            </div>
        </FormModal>

        <FormModal v-if="openUploadModal" @cancel="openUploadModal = false" :valid="uploadCSV != undefined"
            @confirm="uploadTransactions()" title="Add verified transactions"
            subtitle="Upload the verified transaction csv to the system" submitButtonText="Upload">
            <input id="rewardImgUpload" type="file" @change="uploadFile" ref="fileInput" accept=".csv">
        </FormModal>
        <Header title="Cashback offer" icon="BadgePercent" />
        <Breadcrumbs :text1="offer.retailer.retailerName" :link1='`/retailer/${retailerId}`' :text2="'offer/' + offerId"
            :link2='`/retailer/${retailerId}/offer/${offerId}`'>
        </Breadcrumbs>


        <BYOOStatusHeader v-if="offer.supplier == publisherId">
            <CustomButton :requiresConfirmation="false" id="logInAsPublsiher" small text="Edit offer" type="action"
                @click="$router.push('/edit-offer/' + offerId)" />

            <CustomButton :requiresConfirmation="true" id="logInAsPublsiher" small text="Delete offer" type="warning"
                @confirmClick="deleteBYOOOffer()" />

        </BYOOStatusHeader>

        <SubHeader :logo="offer.retailer.logo" :title="offer.retailer.retailerName"
            :subText="offer.retailer.personalisationCategories == null ? '' : offer.retailer.personalisationCategories[0]"
            icon="Store">
            <template v-slot:buttons>
                <a v-if="formattedRetailerWebsite != null" class="" :href="formattedRetailerWebsite" target=”_blank”>
                    <CustomButton id="website" small text="Website" icon="ExternalLink" type="navigate" />
                </a>
                <CustomButton v-if="activatedOffer == undefined" id="logInAsPublsiher" small text="Apply for offer"
                    icon="Percent" type="action" @click="showFormModal = true" />

            </template>
        </SubHeader>

        <WhiteBox v-if="activatedOffer != undefined" title="Offer profile" subText="Overview of key offer information">
            <template v-slot:buttons>
                <!-- <CustomButton id="logInAsPublsiher" small text="Edit cashback splits" icon="Percent" type="action" @click="showFormModal = true" /> -->
                <CustomButton v-if="offer.ownerId == 'BOOGI'" :requiresConfirmation="true"
                    confrimationModalTitle="Remove offer from program"
                    confrimationModalMessage="Confirm you would like to remove this offer, after doing this you will have to re-request approval to gain access to this offer."
                    confrimationModalButtonText="Remove" small text="Remove offer from program" type="warning"
                    icon="Trash2" @confirmClick="deleteOffer()" />

            </template>
            <template v-slot:content>
                <EasyDataTable :table-min-height="0" :headers="activatedOffersHeaders" :items="activatedOfferData"
                    :loading="loading" :hide-footer="true" :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-action="retailer">
                        <div class="flex justify-end gap-x-2 w-full text-right">
                            <div v-if="retailer.offerApproval === 'APPROVED'">
                                <CustomButton v-if="retailer.active" :requiresConfirmation="true"
                                    confrimationModalTitle="Deactivate this offer"
                                    confrimationModalMessage="Confirm you would like to deactivate this offer"
                                    confrimationModalButtonText="Deactivate"
                                    @confirmClick="deActivateOffer(retailer.id)" small text="Deactivate"
                                    type="warning" />
                                <CustomButton v-else :requiresConfirmation="true"
                                    confrimationModalTitle="Active this offer"
                                    confrimationModalMessage="Confirm you would like to activate this offer"
                                    confrimationModalButtonText="Activate" small text="Activate" type="action"
                                    @confirmClick="activateOffer(retailer.id)" />
                            </div>
                            <CustomButton small text="Edit" type="action" @click="handleEditOffer()" />
                        </div>
                    </template>
                    <template #item-supplier="retailers">
                        <Supplier :supplier="retailers.offer.supplier" />
                    </template>
                    <template #item-offertype="retailers">
                        <OfferTypePill :type="retailers.offer.offerType" />
                    </template>
                    <template #item-active="retailer">
                        <StatusPill v-if="retailer.active" text="Live" colour="green" />
                        <StatusPill v-else text="Deactivated" colour="yellow" />
                    </template>
                    <template #item-selectedCustomerTiers="">
                        <StatusPill :class="id > 0 ? 'ml-1' : ''" v-for="tier, id in selectedSegments" :key="id"
                            :text='tier' colour="gray" />
                    </template>

                    selectedSegments

                    <template #item-cap="retailers">
                        <div v-if="retailers.offer.spendingCapped">
                            <StatusPill :text='getCurrencySymbol(this.offer.currency) + retailers.offer.spendingCapAmount' colour="gray" />
                        </div>
                    </template>
                    <template #item-offerApproval="retailer">
                        <StatusPill v-if="retailer.offerApproval === 'APPROVED'" text="Approved" colour="green" />
                        <StatusPill v-if="retailer.offerApproval === 'PENDING'" text="Pending approval"
                            colour="yellow" />
                        <StatusPill v-if="retailer.offerApproval === 'DECLINED'" text="Approval declined"
                            colour="red" />
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
        <div class="grid grid-cols-3 gap-5">
            <div class="col-span-full xl:col-span-2">

                <WhiteBox title="Offer conditions" subText="View breakdown of earnings by conditions">
                    <template v-slot:content>
                        <EasyDataTable :table-min-height="0" :headers="headersTable1" :items="offer.cashbackRules"
                            :loading="loading" :hide-footer="true" :no-hover="true">
                            <template #loading>
                                <div class="p-4 w-full flex justify-center">
                                    <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                </div>
                            </template>
                            <template #empty-message>
                                <div class="flex justify-center py-4">
                                    <div
                                        class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                        <p class="text-sm mr-2">No results</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <template #header-action="header">
                                <div class="w-full text-right">
                                    {{ header.text }}
                                </div>
                            </template>
                            <template #item-usetype>
                                <StatusPill text="Multi-use" colour="blue" />
                            </template>
                            <template #item-customertype="customerType">
                                <StatusPill :text="customerType.customerType" colour="blue" />
                            </template>
                            <template #item-fixedDistributorCommission="val">
                                <div v-if="val.conditions.length === 1" class="">
                                    <StatusPill v-if="val.conditions[0].fixedDistributorCommission" text="True"
                                        colour="green" />
                                    <StatusPill v-else text="False" colour="red" />
                                </div>
                            </template>
                            <template #item-userCashback="val">
                                <CashbackPill v-if="val.conditions.length === 1"
                                    :text="val.conditions[0].value.endUserValue == null ? 'Please set' : val.conditions[0].value.endUserValue.toFixed(2)"
                                    :type="val.conditions[0].value.type" :currency="getCurrencySymbol(this.offer.currency)"
                                    :max="val.conditions[0].value.maximum" />
                            </template>
                            <template #item-totalCashback="val">
                                <div v-if="val.conditions.length === 1">
                                    <CashbackPill v-if="val.conditions[0].value.maxAvailableValue != null"
                                        :text="val.conditions[0].value.maxAvailableValue.toFixed(2)"
                                        :type="val.conditions[0].value.type" :currency="getCurrencySymbol(this.offer.currency)"
                                        :max="val.conditions[0].value.maximum" />
                                    <CashbackPill v-else text="Online offers get a split of commission" />
                                </div>

                            </template>
                            <template #item-publisherCashback="val">
                                <CashbackPill v-if="val.conditions.length === 1"
                                    :text="val.conditions[0].value.clientValue == null ? 'Please set' : val.conditions[0].value.clientValue.toFixed(2)"
                                    :type="val.conditions[0].value.type" :currency="getCurrencySymbol(this.offer.currency)"
                                    :max="val.conditions[0].value.maximum" />
                            </template>
                            <template #item-cashbackType="val">
                                <StatusPill v-if="val.conditions.length === 1" :text="val.conditions[0].value.type"
                                    colour="blue" />
                            </template>
                            <template #item-conditions="val">
                                <div v-if="val.conditions.length === 1" class="">
                                    <div
                                        class="bg-blue-100 border border-blue-400 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap w-min">
                                        <span v-if="val.conditions[0].type === 'GREATER_THAN'">
                                            Greater than {{ getCurrencySymbol(this.offer.currency) }}
                                        </span>
                                        <span v-if="val.conditions[0].type === 'LESS_THAN'">
                                            Less than {{getCurrencySymbol(this.offer.currency)}}
                                        </span>
                                        <span v-if="val.conditions[0].type === 'BETWEEN'">
                                            Between {{getCurrencySymbol(this.offer.currency)}}
                                        </span>
                                        {{ val.conditions[0].lowerBound }}
                                        <span v-if="val.conditions[0].type === 'BETWEEN'">
                                            and {{getCurrencySymbol(this.offer.currency)}}
                                        </span>
                                        {{ val.conditions[0].upperBound }}
                                    </div>
                                </div>
                            </template>
                        </EasyDataTable>
                    </template>
                </WhiteBox>
                <WhiteBox title="Avaliable channels" subText="View the channels this offer can be used by">
                    <template v-slot:content>
                        <EasyDataTable :table-min-height="0" :headers="headersTable4" :items="offer.channels"
                            :loading="loading" :hide-footer="true" :no-hover="true">
                            <template #loading>
                                <div class="p-4 w-full flex justify-center">
                                    <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                </div>
                            </template>
                            <template #empty-message>
                                <div class="flex justify-center py-4">
                                    <div
                                        class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                        <p class="text-sm mr-2">No results</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <template #header-action="header">
                                <div class="w-full text-right">
                                    {{ header.text }}
                                </div>
                            </template>
                        </EasyDataTable>
                    </template>
                </WhiteBox>
                <div v-if="offer.supplier == publisherId">
                    <WhiteBox title="Cashback settlements">
                        <template v-slot:buttons>
                            <CustomButton class="w-48 pt-1 pb-2"
                                @click="openUploadModal = true; verification = verificationObject" small
                                text="Submit transactions" type="action" />
                        </template>

                        <template v-slot:content>
                            <EasyDataTable :table-min-height="0" :headers="settlementsHeader" :items="receivables"
                                :loading="loading" v-model:server-options="serverOptions"
                                :server-items-length="serverItemsLength" :hide-footer="false" :no-hover="true">
                                <template #loading>
                                    <div class="p-4 w-full flex justify-center">
                                        <svg class="animate-spin text-gray-400 w-12 h-12"
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                            </path>
                                        </svg>
                                    </div>
                                </template>
                                <template #empty-message>
                                    <div class="flex justify-center py-4">
                                        <div
                                            class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                            <p class="text-sm mr-2">No results</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                            </svg>
                                        </div>
                                    </div>
                                </template>
                                <template #header-action="header">
                                    <div class="w-full text-right">
                                        {{ header.text }}
                                    </div>
                                </template>

                                <template #item-createdOn="{ createdOn }">
                                    <p>{{ niceDateTime(createdOn) }}</p>
                                </template>

                                <template #item-action="verificationObject">
                                    <div class="flex justify-end gap-x-2 w-full text-right">
                                        <CustomButton class="w-48 pt-1 pb-2" @click="download(verificationObject)" small
                                            text="Download CSV" type="default" />
                                    </div>
                                </template>
                            </EasyDataTable>
                        </template>
                    </WhiteBox>
                </div>
            </div>
            <div class="w-full max-w-md col-span-full xl:col-span-1">
                <WhiteBox title="Display information" subText="Preview the information returned by our offers APIs"
                    fullWidthTitle>
                    <template v-slot:content>
                        <div class="rounded-xl bg-[#F5F2FB] pt-3 pb-4">
                            <!--name-->
                            <!--header-->
                            <div class="px-2 grid gap-2 rounded-xl">
                                <div
                                    class="flex justify-start items-center px-1 py-1 gap-2 w-full h-[60px] bg-white shadow rounded-xl  border border-gray-300">
                                    <img class="object-contain w-[50px] h-[50px] rounded-lg border border-gray-200 bg-white"
                                        :src="offer.displayInformation.logo" />
                                    <div class="">
                                        <p class="font-semibold">{{ offer.displayInformation.retailerName }}</p>
                                    </div>
                                </div>
                                <div
                                    class="p-3 gap-2 w-full bg-white shadow rounded-lg flex justify-between items-center">
                                    <div>
                                        <p class="text-sm font-medium">Cashback:</p>
                                    </div>
                                    <div class="inline">
                                        <span v-if="offer.cashbackRules[0].conditions[0].value.type === 'PERCENTAGE'"
                                            class="bg-green-100 border-2 border-green-400 text-green-700 text-base font-bold pl-4 pr-4 py-2 rounded-full text-nowrap">
                                            {{ offer.cashbackRules[0].conditions[0].value.endUserValue }} %
                                        </span>
                                        <span v-if="offer.cashbackRules[0].conditions[0].value.type === 'FIXED'"
                                            class="bg-green-100 border-2 border-green-400 text-green-700 text-base font-bold px-5 py-2 rounded-full text-nowrap">
                                          {{   offer.cashbackRules[0].conditions[0].value.endUserValue }}
                                        </span>
                                    </div>
                                </div>
                                <div class="p-3 gap-2 w-full bg-white shadow rounded-lg">
                                    <p class="text-sm font-medium mb-1">Description</p>
                                    <p class="text-sm">{{ sanitizedDescription }}</p>
                                </div>
                                <a class="" :href="offer.displayInformation.link" target=”_blank”>
                                    <CustomButton id="website" text="Visit website" icon="" type="action" />
                                </a>
                            </div>
                        </div>
                    </template>
                </WhiteBox>
            </div>
        </div>


    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Breadcrumbs from "@/components/navbars/Breadcrumbs.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import FormModal from "@/components/modals/FormModal.vue";
import { DateTime } from 'luxon';

import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";
import StatusPill from "@/components/StatusPill.vue";
import OfferTypePill from "@/components/OfferTypePill.vue";
import CashbackPill from "@/components/CashbackPill.vue";
import Supplier from "@/components/Supplier.vue";
import BYOOStatusHeader from "@/components/BYOOStatusHeader.vue";
import CustomCheckbox from "@/components/inputs/CustomCheckbox.vue";

export default {
    name: "offer-page",
    components: {
        Header,
        SubHeader,
        WhiteBox,
        Breadcrumbs,
        CustomButton,
        FormModal,
        CustomInput,
        BYOOStatusHeader,
        StatusPill,
        OfferTypePill,
        CashbackPill,
        Supplier,
        CustomSelect,
        CustomCheckbox

    },
    props: {
    },

    data() {
        return {
            publisherId: localStorage.getItem('publisherId'),
            showEditFormModal: false,

            trueOrFalse: [
                { id: "DEFAULT", text: "All users" },
                { id: "TIERED", text: "Selected tiers" },
                { id: "SET", text: "Selected users" },
            ],

            customerSegments: [],

            openUploadModal: false,

            settlementsHeader: [
                { text: "Created on", value: "createdOn" },
                { text: "Download CSV", value: "action" },

            ],
            receivables: [

            ],

            selectedCustomerTiers: [],

            activateOfferRequest: {
                splitOfCashbackPercentage: {
                    endUser: 50,
                    client: 50
                },
                activate: true,
                customerTierType: "DEFAULT",
                selectedCustomerTiers: [],
            },

            headersTable4: [
                { text: "Channel name", value: "channelName" },
                { text: "Address", value: "address" },
                { text: "City", value: "city" },
                { text: "Postcode", value: "postcode" },
                { text: "Channel Type", value: "channelType" },
                { text: "Mids", value: "mids" }

            ],

            declineOffer: { reason: "" },
            selectedOffer: "",
            pecentageNotRight: "",
            successAction: "",

            retailerId: this.$route.params.retailerId,
            offerId: this.$route.params.offerId,
            offer: undefined,
            activatedOffer: undefined,
            activatedOfferData: [],
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            declineModal: false,
            loading: true,

            headersTable1: [
                { text: "Total cashback", value: "totalCashback" },
                { text: "User cashback", value: "userCashback" },
                { text: "Your commission", value: "publisherCashback" },
                { text: "Customer type", value: "customerType" },
                { text: "Use Type", value: "usetype" },
                { text: "Cashback Type", value: "cashbackType" },
                { text: "Fixed split", value: "fixedDistributorCommission" },
                { text: "Spend condition", value: "conditions" },
            ],

            activatedOffersHeaders: [
                { text: "Supplier", value: "supplier" },
                { text: "Country", value: "offer.country" },
                { text: "Currency", value: "offer.currency" },
                
                { text: "Offer type", value: "offertype" },
                { text: "Spending cap", value: "cap" },
                { text: "Availability status", value: "active" },
                { text: "Offer Avaliable to", value: "customerTierType" },
                { text: "Tiers selected", value: "selectedCustomerTiers" },


                { text: "Approval status", value: "offerApproval" },
                { text: "Declined reason", value: "declinedReason" },
                { text: "ACTION", value: "action" },
            ],

            offers: [

            ],
        }
    },
    created() {
        this.getOffer()
        this.getCustomerTiers()

    },
    methods: {

        getCurrencySymbol(currencyCode, locale = 'en-US') {
            return (0).toLocaleString(locale, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).replace(/\d/g, '').trim(); // strip digits, leave symbol
        },

        handleEditOffer() {
            this.showEditFormModal = true
            this.activateOfferRequest.customerTierType = this.activatedOffer.customerTierType
            this.selectedCustomerTiers = this.customerSegments.filter(segment => this.activatedOffer.selectedCustomerTiers.includes(segment.id));


        },

        uploadFile: function () {
            // const file = event.target.files[0];
            this.uploadCSV = event.target.files[0]


        },

        niceDateTime(dateObject) {
            return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATE_MED)
        },

        async getCustomerTiers() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/customer-tier/for-offers`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.customerSegments = object.map(tier => ({
                        id: tier.id,
                        text: tier.name
                    }));

                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },


        async getTransactionVerifications(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer-fulfillment/program-offer/${this.activatedOffer.id}?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.receivables = object.content

                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },

        async uploadTransactions() {

            const formData = new FormData();
            formData.append('multipartFile', this.uploadCSV);

            try {
                const token = localStorage.getItem('token')
                this.loading = true

                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/bring-your-own-offer-fulfillment/upload`, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.openUploadModal = false
                }

            } catch (error) {
                return;
            }
        },


        async activateOffer(offerId) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/activate/${offerId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.successAction = "Offer Activated"
                    this.getOffer()
                    this.showSuccessModal = true
                }

            } catch {
                return
            }
        },

        async deActivateOffer(offerId) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/deactivate/${offerId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.getOffer()
                    this.successAction = "Offer deactivated"
                    this.showSuccessModal = true
                }

            } catch {
                return
            }
        },

        async requestApproval() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')
                this.loading = true


                this.activateOfferRequest.selectedCustomerTiers = this.selectedCustomerTiers.map(val => val.id)

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/apply/${this.offerId}`, {
                    method: "POST",
                    body: JSON.stringify(this.activateOfferRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.loading = false
                    this.getOffer()
                }

            } catch (error) {
                console.log(error)
                return;
            }
        },

        async download(transactionVerification) {
            try {
                const token = localStorage.getItem('token');
                const api = localStorage.getItem('apiType')


                this.loading = true;

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer-fulfillment/${transactionVerification.id}/download`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    const blob = await response.blob(); // Convert the response to a blob
                    const url = window.URL.createObjectURL(blob); // Create a URL for the blob

                    // Create a link element and set its href to the blob URL
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `transaction_verification_boogi_${transactionVerification.id}.csv`); // Set the desired file name

                    document.body.appendChild(link);
                    link.click(); // Programmatically click the link to trigger download

                    document.body.removeChild(link); // Remove the link after the download is triggered
                } else {
                    console.error('Failed to download CSV');
                }
            } catch (error) {
                console.error('Error downloading CSV:', error);
            } finally {
                this.loading = false; // Stop loading
            }
        },


        async deleteOffer() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/delete/${this.activatedOffer.id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.$router.push("/retailer/" + this.retailerId)
                }

            } catch (error) {
                return;
            }

        },

        async deleteBYOOOffer() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/offer/${this.offerId}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.$router.push("/your-catalogue")
                }

            } catch (error) {
                return;
            }
        },


        async getOffer() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/catalogue/offer/${this.offerId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.offer = object
                    this.getActivatedOffer()
                }

            } catch (error) {
                return;
            }

        },

        async getActivatedOffer() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/get/${this.offerId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.activatedOfferData = []
                    this.activatedOffer = object
                    this.activatedOfferData.push(this.activatedOffer)

                    this.offer.cashbackRules = this.activatedOffer.cashbackEarnings
                    this.getTransactionVerifications(0, 25)

                }
                this.loading = false

            } catch (error) {
                return;
            }

        },

    },
    computed: {

        selectedSegments() {

            if (this.activatedOffer) {
                const uniqueTexts = Array.from(
                    new Set(
                        this.activatedOffer.selectedCustomerTiers.map(id => {
                            const match = this.customerSegments.find(seg => seg.id === id);
                            return match ? match.text : null;
                        }).filter(Boolean)
                    )
                );

                return uniqueTexts;
            } else {
                return []
            }

        },

        formattedRetailerWebsite() {
            if (this.offer.retailer.retailerWebsite == null) {
                return null
            }

            // Check if retailerWebsite starts with "https://" or "http://"
            if (this.offer.retailer.retailerWebsite.startsWith('https://') || this.offer.retailer.retailerWebsite.startsWith('http://')) {
                return this.offer.retailer.retailerWebsite;
            } else {
                // If it doesn't, add "https://" prefix
                return `https://${this.offer.retailer.retailerWebsite}`;
            }
        },
        sanitizedDescription() {
            // Remove quotation marks from the description
            return this.offer.displayInformation.description.replace(/"/g, '');
        }
    },
    mounted() {
        document.title = "Dashboard | Cashback offer";
    },
    watch: {
        activateOfferRequest: {
            deep: true,
            handler: function (newValue) {

                if (newValue.splitOfCashbackPercentage.endUser == "") {
                    this.activateOfferRequest.splitOfCashbackPercentage.endUser = 0

                }

                if (newValue.splitOfCashbackPercentage.endUser > 100) {
                    this.activateOfferRequest.splitOfCashbackPercentage.endUser = 100
                    this.pecentageNotRight = "The percentage needs to be less than or equal to 100"
                }
                else if (newValue.splitOfCashbackPercentage.endUser < 0) {
                    this.activateOfferRequest.splitOfCashbackPercentage.endUser = 0
                    this.pecentageNotRight = "The percentage needs to be greater than or equal to 0"

                }
                this.pecentageNotRight = ""
                this.activateOfferRequest.splitOfCashbackPercentage.client = 100 - newValue.splitOfCashbackPercentage.endUser
            },
        }
    }
}
</script>